import format from "date-fns/format";
import { utcToZonedTime } from "date-fns-tz";
export var formatDate = function formatDate(dateToFormat) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MMM dd yyyy, HH:mm:ss";
  return format(dateToFormat, dateFormat);
};
export var utcToTzDate = function utcToTzDate(epoch) {
  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "UTC";
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "MMM dd yyyy, HH:mm:ss";

  if (!epoch) {
    return null;
  }

  return formatDate(utcToZonedTime(new Date(epoch * 1000), timezone), format);
};